import { ActionReducerMap } from '@ngrx/store';
import { APPLICATION_REDUCER, IApplicationState } from './application.reducer';
import { AUTH_REDUCER, IAuthState } from './auth.reducer';
import { ITranscriptionState, TRANSCRIPTION_REDUCER } from './transcription.reducer';
import { CONVERSATION_DATA_REDUCER, IConversationDataState } from './conversation-data.reducer';
import { IScorecardState, SCORECARD_REDUCER } from './scorecard.reducer';
import { CLAIMS_REDUCER, IClaimsState } from './claims.reducer';
import { AGENTS_REDUCER, IAgentsState } from './agents.reducer';
import { IReprocessState, REPROCESS_REDUCER } from './reprocess.reducer';

export interface IRootState {
  [APPLICATION_REDUCER.name]: IApplicationState;
  [AUTH_REDUCER.name]: IAuthState;
  [TRANSCRIPTION_REDUCER.name]: ITranscriptionState;
  [CONVERSATION_DATA_REDUCER.name]: IConversationDataState;
  [SCORECARD_REDUCER.name]: IScorecardState;
  [CLAIMS_REDUCER.name]: IClaimsState;
  [AGENTS_REDUCER.name]: IAgentsState;
  [REPROCESS_REDUCER.name]: IReprocessState;
}

const reducers: ActionReducerMap<IRootState> = {
  [APPLICATION_REDUCER.name]: APPLICATION_REDUCER.reducer,
  [AUTH_REDUCER.name]: AUTH_REDUCER.reducer,
  [TRANSCRIPTION_REDUCER.name]: TRANSCRIPTION_REDUCER.reducer,
  [CONVERSATION_DATA_REDUCER.name]: CONVERSATION_DATA_REDUCER.reducer,
  [SCORECARD_REDUCER.name]: SCORECARD_REDUCER.reducer,
  [CLAIMS_REDUCER.name]: CLAIMS_REDUCER.reducer,
  [AGENTS_REDUCER.name]: AGENTS_REDUCER.reducer,
  [REPROCESS_REDUCER.name]: REPROCESS_REDUCER.reducer,
};

export const reducersFactory = (): ActionReducerMap<IRootState> => reducers;
